(() => {
  const roots = document.querySelectorAll('.local-rental');
  if (!roots.length) return;

  const publish = (root, name, values = {}) => {
    const locationSlug = root.querySelector('[data-local-rental-location]')?.dataset.localRentalLocation || '';
    const payload = Object.fromEntries(Object.entries({ page_type: 'local_rental', local_page_location_slug: locationSlug, ...values }).filter(([, value]) => value !== '' && value != null));
    try {
      if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(name, payload);
    } catch (error) {
      console.warn('Local rental Customer Event publish failed', error);
    }
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...payload });
    document.dispatchEvent(new CustomEvent('daktenter:rental-event', { detail: { name, parameters: payload } }));
  };

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const loadVideo = (video) => {
    if (!video || video.dataset.loaded === 'true' || reducedMotion) return;
    const source = video.dataset.src;
    if (!source) return;
    video.muted = true;
    video.src = source;
    video.dataset.loaded = 'true';
    video.load();
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
  };

  roots.forEach((root) => {
    root.addEventListener('click', (event) => {
      const target = event.target.closest('[data-rental-event]');
      if (!target) return;
      publish(root, target.dataset.rentalEvent, {
        source_section: target.dataset.sourceSection || '',
        model: target.dataset.model || '',
      });
    });

    const modelCards = [...root.querySelectorAll('[data-rental-model-card]')];
    if ('IntersectionObserver' in window) {
      const modelObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.target.dataset.viewTracked === 'true') return;
          entry.target.dataset.viewTracked = 'true';
          publish(root, 'rental_model_card_view', { source_section: 'model_cards', model: entry.target.dataset.model || '' });
          modelObserver.unobserve(entry.target);
        });
      }, { threshold: .55 });
      modelCards.forEach((card) => modelObserver.observe(card));
    }

    const videos = [...root.querySelectorAll('video[data-local-rental-video]')];
    if (reducedMotion) {
      videos.forEach((video) => {
        video.removeAttribute('autoplay');
        video.pause();
      });
    } else if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadVideo(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '240px 0px' },
      );
      videos.forEach((video) => observer.observe(video));
    }

    root.querySelectorAll('.local-rental__services-track, .local-rental__model-track').forEach((track) => {
      track.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        const card = track.querySelector('.local-rental__fact, .local-rental__model-card');
        if (!card) return;
        event.preventDefault();
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: (card.getBoundingClientRect().width + gap) * (event.key === 'ArrowRight' ? 1 : -1), behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    });

    const sticky = root.querySelector('[data-local-rental-sticky]');
    const introCta = root.querySelector('.local-rental__intro-button');
    if (sticky) {
      let introVisible = true;
      const visibleControls = new Set();
      const interferenceTargets = [...root.querySelectorAll('.local-rental__button, .local-rental__accessory-grid a, .local-rental__models, .local-rental__accessories')]
        .filter((element) => !element.closest('[data-local-rental-sticky]') && element !== introCta);
      const updateSticky = () => {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        sticky.classList.toggle('is-visible', mobile && !introVisible && visibleControls.size === 0);
      };
      if ('IntersectionObserver' in window) {
        const stickyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === introCta) introVisible = entry.isIntersecting;
            else if (entry.isIntersecting) visibleControls.add(entry.target);
            else visibleControls.delete(entry.target);
          });
          updateSticky();
        }, { threshold: [0, .15] });
        if (introCta) stickyObserver.observe(introCta);
        interferenceTargets.forEach((target) => stickyObserver.observe(target));
      }
      window.addEventListener('resize', updateSticky, { passive: true });
      updateSticky();
    }
  });
})();
